export var countryList1 = ['id-ID', 'nl-NL', 'pt-PT', 'pt-BR', 'es-ES', 'es-MX', 'tr-TR', 'vi-VN', 'ro-RO', 'de-DE', 'it-IT'];
export var countryList2 = ['ru-RU', 'uk-UA', 'pl-PL', 'kk-KZ', 'fr-FR', 'ka-GEO', 'ru-GEO'];
var numFormat;

/**
 * 千分位正则匹配方式,去除千分位中的符号
 * TYPE1：  千分位用点号，小数用逗号，如id-ID
 * TYPE2：  千分位用空格，小数用逗号，如ru-RU(1000-9999不加空格，从10 000开始加空格)
 * DEFAULT：千分位用逗号，小数用点号
 */
export var getCountryTypeByLang = function getCountryTypeByLang(language) {
  if (countryList1.includes(language)) return 'TYPE1';
  if (countryList2.includes(language)) return 'TYPE2';
  return 'DEFAULT';
};

// 根据countryType格式化num
var numberFormatFn = function numberFormatFn(num, countryType) {
  var language = 'en';
  if (['TYPE1'].includes(countryType)) {
    language = 'id-ID';
  } else if (['TYPE2'].includes(countryType)) {
    language = 'ru-RU';
  }
  try {
    numFormat = new Intl.NumberFormat(language, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    });
  } catch (e) {
    // 如果出现错误，使用回退en-US
    console.warn("Invalid locale, falling back to en");
    numFormat = new Intl.NumberFormat('en');
  }
  // (1000-9999不加空格，从10 000开始加空格)
  if (['TYPE2'].includes(countryType) && num >= 1000 && num < 10000) return num;
  return numFormat.format(num);
};

// 保留小数点后precision位,例如默认精度是4位，value传入5位，则只保留4位
export var toSlice = function toSlice(num, precision) {
  if (precision === '' || precision === null || precision === undefined || +precision < 0 || isNaN(precision)) {
    return num === null || num === void 0 ? void 0 : num.toString();
  }
  var newPrecision = precision ? +precision : 0;
  var str = num.toString();
  var index = str.indexOf('.');
  if (index !== -1) {
    str = str.slice(0, index + 1 + newPrecision);
    if (newPrecision <= 0) return str.split('.')[0];
    return str;
  }
  return str;
};
export var replaceByLang = function replaceByLang(str, language, isPaste) {
  var countryType = getCountryTypeByLang(language);
  if (countryType === 'TYPE1') {
    if (isPaste && !str.includes(',')) {
      return str.replace(/[,，]/g, '.');
    }
    return str.replace(/\./g, '').replace(/[,，]/g, '.');
  } else if (countryType === 'TYPE2') {
    if (str.endsWith('.')) {
      return str.replace(/[,.]+$/g, '');
    }
    return str.replace(/\s/g, '').replace(/[,，]/g, '.');
  }
  return str.replace(/,/g, '').replace(/[。]/g, '.');
};

/**
 * @param value  传入的值，如：12345.6789
 * @param precision 保留精度，默认8
 * @param language 语言
 * 展示用例：displayThousands('12345.6789', 2, 'de-DE')
 */
export var displayThousands = function displayThousands(value, precision) {
  var _toSlice;
  var language = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'en';
  if (value === 0) return '0';
  if (!value || isNaN(+value)) return '';
  var countryType = getCountryTypeByLang(language);
  // decimal 小数点
  var decimal = ['TYPE1', 'TYPE2'].includes(countryType) ? ',' : '.';
  var newValue = (_toSlice = toSlice(value, precision)) === null || _toSlice === void 0 ? void 0 : _toSlice.replace(/\./g, decimal);
  var arr = newValue.split(decimal);
  arr[0] = numberFormatFn(arr[0], countryType);
  return arr.join(decimal);
};

/**
 * @param value  传入的值，如：12345.12
 * @param precision 保留精度(四舍五入，并且严格精度，不满精度位数强行补零)，默认4
 * @param language 语言
 * 展示用例：formatNumber('12345.12', 4, 'de-DE') =》 12.345,1200
 */
export var formatNumber = function formatNumber(value, precision) {
  var _Number, _toSlice2;
  var language = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'en';
  if (value === 0) return '0';
  if (!value || isNaN(+value)) return '';
  var newPrecision = precision ? precision : precision === 0 ? 0 : 4;
  var countryType = getCountryTypeByLang(language);
  var v = (_Number = Number(value)) === null || _Number === void 0 ? void 0 : _Number.toFixed(newPrecision);
  // decimal 小数点
  var decimal = ['TYPE1', 'TYPE2'].includes(countryType) ? ',' : '.';
  var newValue = (_toSlice2 = toSlice(v, newPrecision)) === null || _toSlice2 === void 0 ? void 0 : _toSlice2.replace(/\./g, decimal);
  var arr = newValue.split(decimal);
  arr[0] = numberFormatFn(arr[0], countryType);
  return arr.join(decimal);
};